module.exports = __webpack_public_path__ + "media/src/assets/Images/AboutUsBackground-28a0e70a3abe3511a45bb6b71313fcf4.svg";